(function () {
  function formulario() {
    return document.querySelector('#comprar') ||
      document.querySelector('product-form-component') ||
      document.querySelector('form[action*="/cart/add"]');
  }
  function ir(e) {
    var f = formulario();
    if (!f) return;
    if (e) e.preventDefault();
    var y = f.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pv-comprar]');
    if (!a) return;
    if (a.getAttribute('href').charAt(0) === '#') ir(e);
  });
  if (location.hash === '#comprar') {
    window.addEventListener('load', function () { setTimeout(ir, 150); });
  }
})();

/* Order bump: reemplaza scheduleUcbProdAdd de la app (truena si localStorage
   no está listo y muestra "Some Error Occured"). Misma lógica, sin alertas. */
(function () {
  function leer() {
    try {
      var q = JSON.parse(localStorage.getItem('theUcbJobQueues') || '{}');
      return q && typeof q === 'object' ? q : {};
    } catch (e) { return {}; }
  }
  function guardar(q) {
    try { localStorage.setItem('theUcbJobQueues', JSON.stringify(q)); } catch (e) {}
  }
  function bump(el, prodId, varId, prodTitle) {
    var titulo = '';
    try { titulo = decodeURIComponent(escape(atob(prodTitle || ''))); } catch (e) {}
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var marcado = el.checked;
    var cuerpo;
    if (marcado) {
      cuerpo = { items: [{ id: varId, quantity: 1, properties: { _ucbProduct: 'yes', _refProdId: prodId, _refProdTitle: titulo } }] };
    } else {
      cuerpo = { updates: {} };
      cuerpo.updates[varId] = 0;
    }
    el.disabled = true;
    fetch(raiz + (marcado ? 'cart/add.js' : 'cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var q = leer();
      q[prodId] = q[prodId] || {};
      if (marcado) q[prodId][varId] = { status: true }; else delete q[prodId][varId];
      guardar(q);
    }).catch(function () {
      el.checked = !marcado;
    }).then(function () { el.disabled = false; });
  }
  function instalar() { window.scheduleUcbProdAdd = bump; }
  instalar();
  document.addEventListener('DOMContentLoaded', instalar);
  window.addEventListener('load', instalar);
})();

/* Compra directa: "Comprar ahora" y los botones exprés llevan al pago con el
   recetario y, si la casilla está marcada, el 99. Sin pasar por el carrito. */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var yendo = false;
  function forma() { return document.querySelector('form[action*="/cart/add"]'); }
  function casilla() { return document.querySelector('.theUcbInputCbox'); }
  function varianteBump(cb) {
    var m = (cb && cb.className || '').match(/theucb-\d+-(\d+)/);
    return m ? m[1] : null;
  }
  function alPago(e) {
    var f = forma();
    var idEl = f && f.querySelector('input[name="id"]');
    if (!idEl) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (yendo) return;
    yendo = true;
    var updates = {};
    updates[idEl.value] = 1;
    var cb = casilla();
    var bv = varianteBump(cb);
    if (bv) updates[bv] = cb.checked ? 1 : 0;
    fetch(raiz + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      window.location.href = raiz + 'checkout';
    }).catch(function () {
      yendo = false;
      f.submit();
    });
  }
  function esPaginaVenta() { return !!document.querySelector('.pv-hero'); }
  function enCamino(e, selector) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.nodeType === 1 && n.matches && n.matches(selector)) return true;
    }
    return false;
  }
  document.addEventListener('submit', function (e) {
    if (!esPaginaVenta()) return;
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) alPago(e);
  }, true);
  document.addEventListener('click', function (e) {
    if (!esPaginaVenta()) return;
    if (enCamino(e, 'form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]')) {
      alPago(e);
      return;
    }
    var cb = casilla();
    if (cb && cb.checked && enCamino(e, 'shopify-accelerated-checkout, .shopify-payment-button, .accelerated-checkout-block')) {
      alPago(e);
    }
  }, true);
  function etiqueta() {
    if (!esPaginaVenta()) return;
    document.querySelectorAll('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]').forEach(function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT);
      var t;
      while ((t = w.nextNode())) {
        if (/agregar al carrito/i.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/agregar al carrito/i, 'Comprar ahora');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', etiqueta);
  window.addEventListener('load', etiqueta);
})();
